import GrayCard from "components/gray-card";
import DragNDrop from "components/inputs/dragNdrop";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { BytesToMB } from "utils/numberConvert";

interface IProps {
  file: File | undefined;
  onChangeFile: (file: File | undefined) => void;
}
const VideoUploadCard = ({ file, onChangeFile }: IProps) => {
  return (
    <GrayCard title="Upload Your Music Video">
      <VideoInputContainer>
        {!file ? (
          <DragNDrop
            setFile={(file) => {
              onChangeFile(file);
            }}
            type="video"
            limit={500}
          />
        ) : (
          <UploadedVideoDetails>
            <CancelButton onClick={() => onChangeFile(undefined)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle cx="11.9998" cy="12.0003" r="5.14286" fill="#1E1E1E" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z"
                  fill="#CDCDCD"
                />
              </svg>
            </CancelButton>
            <VideoIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.09146 1.667H12.9082C13.102 1.66695 13.2505 1.66691 13.3803 1.67961C14.3035 1.76992 15.0591 2.32497 15.3796 3.07264H4.62012C4.94054 2.32497 5.69618 1.76992 6.61936 1.67961C6.74919 1.66691 6.89773 1.66695 7.09146 1.667Z"
                  fill="#909090"
                />
                <path
                  d="M5.25867 3.93555C4.09981 3.93555 3.14959 4.63534 2.83248 5.5637C2.82588 5.58305 2.81953 5.60251 2.81348 5.62206C3.14527 5.52158 3.49058 5.45594 3.84013 5.41113C4.74044 5.29571 5.87823 5.29576 7.19992 5.29584H12.9433C14.265 5.29576 15.4028 5.29571 16.3032 5.41113C16.6527 5.45594 16.998 5.52158 17.3297 5.62206C17.3237 5.60251 17.3174 5.58305 17.3107 5.5637C16.9937 4.63534 16.0434 3.93555 14.8846 3.93555H5.25867Z"
                  fill="#909090"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.7728 6.28516H7.22683C4.41449 6.28516 3.00831 6.28516 2.21844 7.10751C1.42856 7.92987 1.6144 9.20037 1.9861 11.7415L2.33857 14.151C2.63005 16.1438 2.7758 17.1401 3.52345 17.7368C4.27111 18.3335 5.37384 18.3335 7.57929 18.3335H12.4203C14.6258 18.3335 15.7286 18.3335 16.4763 17.7368C17.2239 17.1401 17.3696 16.1438 17.6611 14.151L18.0136 11.7415C18.3853 9.20046 18.5711 7.92986 17.7813 7.10751C16.9913 6.28516 15.5852 6.28516 12.7728 6.28516ZM12.1508 13.162C12.6162 12.8735 12.6162 12.1267 12.1508 11.8383L9.34117 10.0965C8.88892 9.81612 8.33317 10.181 8.33317 10.7584V14.2419C8.33317 14.8192 8.88892 15.1841 9.34117 14.9038L12.1508 13.162Z"
                  fill="#909090"
                />
              </svg>
            </VideoIcon>
            <Typography size="xs" weight="semibold" mb="0.3">
              {file.name}
            </Typography>
            <Typography size="xs" color={Colors.grey500}>
              {BytesToMB(file.size)}MB
            </Typography>
          </UploadedVideoDetails>
        )}
      </VideoInputContainer>
      <Typography size="s" weight="semibold">
        Video File Requirements
      </Typography>
      <UnorderedList>
        <li>
          <Typography size="s">
            File format must be .mov, .mp4, .wmv, .flv, .mkv
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">Minimum resolution. 1280 x 720</Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            No lyric videos. Streaming services wll reject videos with overlaid
            text, including lyrics , subtitles, and artist names.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            No ads. Streaming services wll reject videos with release dates,
            logos or ads.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            No still images or promos. Streaming services wll reject videos that
            only show the album art or slide shows.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            No partial songs. Videos that have been shortened or edited into a
            promotional teaser, trailer or partial version will be rejected
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            No medleys, one song per video. Music videos must contain only one
            song.
          </Typography>
        </li>
      </UnorderedList>
      <InfoDiv>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6ZM6 8.875C6.2071 8.875 6.375 8.7071 6.375 8.5V5.5C6.375 5.2929 6.2071 5.125 6 5.125C5.7929 5.125 5.625 5.2929 5.625 5.5V8.5C5.625 8.7071 5.7929 8.875 6 8.875ZM6 3.5C6.27615 3.5 6.5 3.72386 6.5 4C6.5 4.27614 6.27615 4.5 6 4.5C5.72385 4.5 5.5 4.27614 5.5 4C5.5 3.72386 5.72385 3.5 6 3.5Z"
            fill="#909090"
          />
        </svg>
        <Typography size="s">
          Streaming services require high quality music videos, services with
          unintentional quality problems including glitches, audio problems,
          out-of-sync audio etc. Will be rejected.{" "}
        </Typography>
      </InfoDiv>
    </GrayCard>
  );
};

export default VideoUploadCard;

const VideoInputContainer = styled.div`
  height: 8.6rem;
  width: 100%;
  margin-bottom: 1rem;
`;

const UploadedVideoDetails = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${Colors.grey600};
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;

const VideoIcon = styled.div`
  width: 2rem;
  height: 2rem;
  margin-bottom: 0.3rem;
`;

const CancelButton = styled.div`
  position: absolute;
  top: -1.2rem;
  right: -1.2rem;
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;
`;

const UnorderedList = styled.ul`
  color: ${Colors.grey500};
  padding-left: 1.5rem;
  width: 55%;
  margin-bottom: 2.4rem;

  li {
    margin-bottom: 0.4rem;
    font-size: 1rem;
  }

  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const InfoDiv = styled.div`
  display: grid;
  grid-template-columns: 3% 97%;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${Colors.grey500};
  @media only screen and (max-width: 769px) {
    grid-template-columns: 5% 94%;
  }
`;
